// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__3MbAn","spin":"Spinner_spin__15_L8"};